import { Link } from '@tanstack/react-router'
import { JobillaLogo } from '../../rapid-ui'

export function JobillaBrandLogo() {
	return (
		<Link to="/" className="flex items-center gap-2 max-w-30">
			<JobillaLogo />
		</Link>
	)
}
